import React, { memo, useEffect, useState } from 'react'
import clsx from 'clsx'
import { Controller } from 'react-hook-form'
import { FormattedMessage, useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid2'
import { whatsappEasyAgencias } from 'vars'
import EventEmitter from 'services/EventEmitter'
import { useRouter } from 'next/router'
import InputAdornment from '@mui/material/InputAdornment'
import IconButton from '@mui/material/IconButton'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { signIn } from 'next-auth/react'
import { Alert } from '@mui/material'
import dynamic from 'next/dynamic'
import SearchingIcon from 'components/icons/searching.svg'
import usePersonalDataForm from './usePersonalDataForm'
import sx from './styles'

const LoadingDialogDynamic = dynamic(() => import('components/UI/LoadingDialog'))

const AcutionLogin = ({
  login = {},
  handleCloseModal,
}) => {
  const { formatMessage: f } = useIntl()
  const { personalData } = useSelector((s) => s.checkout)
  const [error, setError] = useState(null)
  const [requestDialog, setRequestDialog] = useState(null)
  const router = useRouter()
  const {
    // getValues,
    formState,
    control,
    user,
    password,
  } = usePersonalDataForm(login)

  const [showPassword, setShowPassword] = useState(false)

  const handleClickShowPassword = () => setShowPassword((show) => !show)

  const handleMouseDownPassword = (event) => {
    event.preventDefault()
  }

  const dataRequestDialog = {
    mainTitle: f({ id: 'AUCTION_LOADER_TITLE' }),
    description: [
      f({ id: 'AUCTION_LOADER_SUBTITLE' }),
    ],
    icon: <SearchingIcon />,
  }

  const whatsappMessageForgotPassword = 'Hola, necesito ayuda. Olvidé mi contraseña, me pueden ayudar.'

  const handleSubmit = async () => {
    // const values = getValues()
    // onSubmitProp(values, showModal)
    const resp = await signIn('credentials', {
      redirect: false, email: user, password,
    })

    if (resp?.ok) {
      setError(null)
      setRequestDialog(dataRequestDialog)
      setTimeout(() => {
        setRequestDialog(null)
        handleCloseModal()
        router.push('subastas/autos')
      }, 3000)
    } else {
      setError('Error')
    }
  }

  useEffect(() => {
    if (personalData > 0) {
      handleSubmit(true)
    }
  }, [personalData])

  return (
    <>
      <Box sx={sx.root}>
        <Box>

          <Box sx={{ ...sx.contentController, ...sx.inputGroup }}>
            <Controller
              name="user"
              control={control}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  sx={sx.field}
                  required
                  placeholder={f({
                    id: 'AUCTIONS_LOGIN_USER_FIELD',
                  })}
                  label={`${f({
                    id: 'AUCTIONS_LOGIN_USER_FIELD',
                  })}`}
                  value={field.value}
                  onChange={(e) => {
                    field.onChange(e)
                  }}
                  fullWidth
                  error={fieldState.invalid}
                  className={clsx('Mui-style', { touched: user })}
                />
              )}
            />
          </Box>

          <Box sx={{ ...sx.contentController, ...sx.inputGroup }}>
            <Controller
              name="password"
              control={control}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  sx={sx.field}
                  required
                  placeholder={f({
                    id: 'AUCTIONS_LOGIN_PASSWORD_FIELD',
                  })}
                  label={`${f({
                    id: 'AUCTIONS_LOGIN_PASSWORD_FIELD',
                  })}`}
                  InputProps={{
                    endAdornment:
                      (
                        <InputAdornment
                          position="end"
                        >
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                  }}
                  type={showPassword ? 'text' : 'password'}
                  value={field.value}
                  onChange={(e) => {
                    field.onChange(e)
                  }}
                  fullWidth
                  error={fieldState.invalid}
                  className={clsx('Mui-style', { touched: password })}
                />
              )}
            />
          </Box>

        </Box>

        {error && (
          <Alert severity="error">Hubo un error. Revisa tu usuario o contraseña</Alert>
        )}

        <Box
          sx={sx.finishLaterContent}
        >
          <Button
            fullWidth
            color="primary"
            variant="special"
            sx={sx.btn}
            disabled={(!formState.isValid)}
            onClick={() => { handleSubmit() }}
          >
            <FormattedMessage id="AUCTIONS_LOGIN_MAIN_CTA" />
          </Button>
        </Box>

        <Grid
          container
          sx={sx.linksContainers}
        >
          <Grid
            size={12}
            sx={sx.linklogin}
          >
            <Button
              variant="text"
            >
              <Typography
                component="a"
                variant="link-text"
                sx={sx.linkText}
                target="_blank"
                rel="noopener noreferrer"
                href={`//wa.me/${whatsappEasyAgencias}?text=${whatsappMessageForgotPassword}`}
              >
                <FormattedMessage
                  id="AUCTIONS_LOGIN_FORGOT_PASSWORD"
                  values={{ br: <br /> }}
                />
              </Typography>
            </Button>
          </Grid>
          <Grid
            size={12}
            sx={sx.linklogin}
          >
            <Button
              variant="text"
              onClick={() => EventEmitter.emit('open-register')}
            >
              <Typography
                variant="link-text"
                sx={sx.linkText}
              >
                <FormattedMessage
                  id="AUCTIONS_LOGIN_SWITH_REGISTER"
                  values={{ br: <br /> }}
                />
              </Typography>
            </Button>
          </Grid>
        </Grid>

      </Box>

      {requestDialog !== null && (
        <LoadingDialogDynamic
          open={requestDialog !== null}
          {...requestDialog}
        />
      )}
    </>
  )
}

export default memo(AcutionLogin)
